/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import PropTypes from "prop-types";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import MainNav from "./mainNav";
import * as style from "./header.module.css";

const Header = ({ siteTitle, lang, langList, navLinks }) => {
  let homePath = lang + "/";
  if (homePath === "en/") {
    homePath = "";
  }

  const getScrollHeight = () => {
    const body = document.body;
    const html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  };

  React.useEffect(() => {
    if (getScrollHeight() >= 2 * window.innerHeight) {
      const progress = document.getElementById("header-progress");
      window.addEventListener("scroll", () => {
        let transform = 1 - window.scrollY / (getScrollHeight() - window.innerHeight);
        progress.setAttribute("style", `transform: scaleX(${transform});`);
      });
    }
  }, []);

  return (
    <header className={style.header}>
      <div id="header-progress" className={style.progress} />
      <div className={style.content}>
        <h1 className={style.siteTitle}>
          <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/" + homePath} className={style.link}>
            {siteTitle}
          </AniLink>
        </h1>
        <div className={style.siteTitleBefore} />
        <div className={style.siteTitleAfter} />
        <MainNav lang={lang} langList={langList} navLinks={navLinks} />
      </div>
    </header>
  );
};

Header.defaultProps = {
  siteTitle: ``,
  lang: `en`,
  langList: [],
  navLinks: [],
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  lang: PropTypes.string,
  langList: PropTypes.array,
  navLinks: PropTypes.array,
};

export default Header;
